import React, { useState } from 'react';
import {
    Alert,
    Button,
    Paper,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import ReprogramacionCriterios from './ReprogramacionCriterios';
import { dateTimeUiToApi } from '../../const/dates';

/**
 * Panel de reprogramación de turno.
 */
export default function ReprogramarPanel({ orden, onSubmit, disabled = false }) {
    const [turnoEn, setTurnoEn] = useState('');
    const [motivo, setMotivo] = useState('');

    const puede = !!orden?.puede_reprogramar && !disabled;
    const requiereExcepcion = !!orden?.reprogramar_requiere_excepcion;
    const bloqueos = orden?.reprogramar_bloqueos || [];

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
                Reprogramar turno
            </Typography>

            <ReprogramacionCriterios
                ordenOrPractica={orden}
                bloqueos={bloqueos}
            />

            {requiereExcepcion ? (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Reprogramación con excepción de administrador. Queda registrada en auditoría.
                </Alert>
            ) : null}

            <Stack spacing={2}>
                <TextField
                    label="Nueva fecha y hora del turno"
                    type="datetime-local"
                    value={turnoEn}
                    onChange={(e) => setTurnoEn(e.target.value)}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    size="small"
                    disabled={!puede}
                />
                <TextField
                    label="Motivo"
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                    fullWidth
                    multiline
                    minRows={2}
                    size="small"
                    disabled={!puede}
                    helperText="El motivo queda registrado en el historial de auditoría."
                    required
                />
                <Button
                    variant="contained"
                    color={requiereExcepcion ? 'warning' : 'primary'}
                    disabled={!puede || !turnoEn || !motivo.trim()}
                    onClick={() => onSubmit({
                        turno_en: dateTimeUiToApi(turnoEn),
                        motivo: motivo.trim(),
                    })}
                >
                    Reprogramar
                </Button>
            </Stack>
        </Paper>
    );
}
